import { BondConfigItem } from '@bdswiss/mt4-connector'
import React from 'react'
import { calculateEffectiveYield } from '@bdswiss/mt4-connector'
import { Translate } from 'react-redux-i18n'
import HelpTooltip from './HelpTooltip'

interface Props {
  bond: BondConfigItem
  onSelectBond: (bond: BondConfigItem) => void
  onViewBondDetails: (bond: BondConfigItem) => void
  key: string
}

class BondsListItem extends React.Component<Props> {
  private bond: BondConfigItem
  constructor(props: Props) {
    super(props)
    this.bond = props.bond
    // this.selectBond = this.selectBond.bind(this);
  }

  public render() {
    const bond = this.bond
    const effectiveYield = calculateEffectiveYield(bond, 10000).toFixed(2)
    let shortenedDescription = ''
    if (bond.businessDescriptionShort) {
      shortenedDescription = bond.businessDescriptionShort.substr(0, 80)
      if (bond.businessDescriptionShort.length > 80) {
        shortenedDescription += '...'
      }
    }
    return (
      <div className="bonds">
        <div className="bonds__image">
          <img
            src={bond.promoImageUrl}
            alt={bond.name}
            onClick={() => {
              this.props.onViewBondDetails(bond)
            }}
          />
        </div>
        <div className="leveraged_interest fz-14">
          <Translate value={'leveragedInterest'} />
          <HelpTooltip content="bondNetInterestDescription" />
          <span className="leveraged_interest__value font-weight-medium fz-18">
            {effectiveYield}%
          </span>
        </div>
        <div
          className="bonds__content"
          onClick={() => {
            this.props.onViewBondDetails(bond)
          }}
          data-cy={bond.name}
        >
          <div className="d-flex justify-content-between">
            <div className="">
              <div className="font-weight-medium fz-18 color-33 bond-title">{bond.name}</div>
              <div className="font-weight-medium fz-14 color-33">{bond.establishedYear}</div>
            </div>
            <div className="bonds__logo">
              <img src={bond.logoUrl} alt="" />
            </div>
          </div>
          <div className="color-75 fz-14">{bond.assetSecurity}</div>
          <div className="fz-14 color-33 bond-short-description">{shortenedDescription}</div>
          <div className="read-more-link">
            <span>
              <Translate value={'readMore'} />
              &nbsp;&#x226B;
            </span>
          </div>
          <button
            className="btn black_button col-12"
            onClick={e => {
              e.stopPropagation()
              this.props.onSelectBond(bond)
            }}
          >
            <Translate value={'buy'} data-cy="buy" />
          </button>
        </div>
      </div>
    )
  }
}

export default BondsListItem
